import getConfig from "next/config"
const { publicRuntimeConfig } = getConfig()

export const AP_STAGE = publicRuntimeConfig.AP_STAGE
export const AP_PINMED_URL = publicRuntimeConfig.AP_PINMED_URL

// pinmed 前台站台網址，供「前往院所/醫師頁面」等連結組裝使用
export const PINMED_SITE_URL =
  AP_STAGE === "staging" ? "https://pinmed-staging.vercel.app" : "https://pinmed.co"
